<template>
    <div class="columns invoice-table-component">
        <div class="column is-12" v-show="!create" style="height:90vh;">
			<div class="header invoice-table-header">
				<button class="is-warning button" @click="createBatch = true" :disabled="!selected.length">BATCH</button>
				<b-modal :active="createBatch" has-modal-card trap-focus aria-role="dialog" aria-modal>
					<batch-modal :createBatch.sync="createBatch" :selected.sync="selected" @refetch="fetch" />
	        	</b-modal>
	        	<button class="button" style="float:right;" @click="$emit('update:invoice', null)">Create</button>
				<!-- <button class="is-info button" style="position:absolute; right:15px; top:20px;" @click="create = true, invoice = null">CREATE</button> -->
			</div>
			<base-table
				:service="$options.invoiceService"
				fetch-func="all"
				:fetch-params="params"
				:columns="columns"
				default-sort-direction="desc"
				:narrowed="false"
				ref="baseTable"
				:sticky="true"
				:selectable="true"
				:selected="invoice"
				@click="rowClicked"
				>
				<template #rowCheckBox="{ row }">
					<b-checkbox  v-model="selected" :native-value="row.id" :disabled="row.batch ? true : false"></b-checkbox>
				</template>
				<template #rowStatus="{ row }">
					{{ row.approved_at ? 'Approved' : '' }}
				</template>
				<!-- <template #rowDate="{ row }">
					{{ convertDate(row.date) }}
				</template>
				<template #rowBatch="{ row }">
					{{ row.batch ? row.batch.text : 'None' }}
				</template> -->
				<template #rowAction="{ row }">
					<button type="button" class="button is-warning is-small" @click="approved(row.id)" v-if="!row.approved_at && displayApprovedButton(row)">Approved</button>
					<!-- <button type="button" class="button" @click="create = true, invoice = row">Edit</button> -->
				</template>
			</base-table>
        </div>

        <!-- <div class="column is-12" v-if="create">
        	<invoice-form :create.sync="create" @refetch="fetch" :invoice="invoice" />
        </div> -->
    </div>
</template>
<script>
import BaseTable from "@/components/partials/BaseTable";
import InvoiceForm from "./form";
import BatchModal from "./batchModal";
import { InvoiceService } from "@/services/invoice.service";
import { BatchService } from "@/services/batch.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer.js";
import moment from "moment";
export default {
	invoiceService: InvoiceService,
  	components: {
    	BaseTable, InvoiceForm, BatchModal,
  	},
	props: [ 'filter', 'invoice' ],
    data: () => ({
	    params: {
	    	includes: 'approvedBy,order,order.firm,tags',
	    	// batch: null,
	    	filter: null
	    },
    	create: false,
    	createBatch: false,
    	selected: [],
	    searchBatch: '',
	    batches: [],
    }),
    computed: {
	    columns() {
	        let columns = [];
			columns.push({meta: {
	            rowSlot: "rowCheckBox",
	            class: 'checkbox-column'
	        }});
	        columns.push({field: "id", label: "Id"});
	        columns.push({field: "text", label: "Text"});
	        columns.push({field: "number", label: "Number"});
			columns.push({label: "Status", meta: {
	            rowSlot: "rowStatus",
	        }});
			columns.push({label: "Action", meta: {
	            rowSlot: "rowAction",
	            class: 'action-td'
	        }});
	        return columns;
	    },
	    filtererBatches() {
	    	if (this.searchBatch) {
		    	return this.batches.map(element => element.id + ' - ' + moment(element.date).format("DD-MMM-YYYY") + ' - ' +  element.text).filter(element => {
		    		return element.toLowerCase().includes(this.searchBatch.toLowerCase());
		    	});
	    	}
	    },
	    user() {
	    	return this.$store.state.Auth.user;
	    },
	},
	methods: {
		rowClicked(row) {
			this.$emit('update:invoice', row)
		},
	    displayApprovedButton(row) {
	    	return row.approvedBy && this.user.id == row.approvedBy.id;
	    },
		approved(id) {
			InvoiceService.approved(id).then(response => {
      			this.$buefy.toast.open({
	                message: 'Success',
	                type: "is-success",
					position: "is-top-right"
	            });
	            this.fetch();
			})
		},
		editData(row) {
			// this.invoice = row;
		},
		fetch() {
			this.$nextTick(() => {
				this.params.filter = this.filter
			})
			this.$nextTick(() => {
				this.$refs.baseTable.fetchData();
			})
		},
		convertDate(date) {
			return moment(date).format("MM/DD/YYYY");
		}
	},
	mounted() {

	}
};
</script>
<style lang="scss">
.invoice-table-component {
	.action-td{
		width: 20px;
		text-align: right !important;
	}
	.has-sticky-header{
		height: 80vh !important;
	}
	.invoice-table-header {
		padding: 10px 10px 15px;
		// display: block;
	}
	.checkbox-column {
		width: 10px;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/invoices/table.vue